(function () {
  'use strict';
  const db = () => window.SM.DB;
  const ui = () => window.SM.UI; 
  const util = () => window.SM.UTIL;

  async function load() {
    const tbody = document.getElementById('ims-imports-tbody');
    if (!tbody) return;
    tbody.innerHTML = `<tr><td colspan="8" class="ims__table-empty"><i class="ti ti-loader-2 ims__spin"></i></td></tr>`;
    const search = document.getElementById('ims-imports-search')?.value?.trim().toLowerCase() || '';
    const status = document.getElementById('ims-imports-status')?.value || '';
    const opts = { select: 'id,container_number,status,eta,arrival_date,landed_cost,origin_country,port_of_entry,created_at,suppliers(name),purchase_orders(po_number)', order: { col: 'created_at', asc: false } };
    if (status) opts.eq = { status };
    const { data: imports, error } = await db().select('imports', opts);
    if (error) { ui().toast('Failed to load imports', 'error'); return; }
    let items = imports || [];
    if (search) items = items.filter(i => i.container_number?.toLowerCase().includes(search) || i.origin_country?.toLowerCase().includes(search) || i.suppliers?.name?.toLowerCase().includes(search) || i.purchase_orders?.po_number?.toLowerCase().includes(search) || i.port_of_entry?.toLowerCase().includes(search));
    // Hide landed cost column for non-privileged roles
    const costTh=document.getElementById('ims-imp-cost-th');
    if(costTh) costTh.style.display=window.SM.AUTH.canSeeCost()?'':'none';

    const pending = items.filter(i => ['ordered','in_transit','customs'].includes(i.status)).length;
    const grnPending = items.filter(i => i.status === 'grn_pending').length;
    ui().updateBadge('ims-badge-imports', pending + grnPending);
    if (!items.length) { tbody.innerHTML = '<tr><td colspan="8" class="ims__table-empty">No imports found</td></tr>'; return; }
    tbody.innerHTML = items.map(imp => `<tr>
      <td><span class="ims__link" onclick="window.IMS_IMPORTS.openContainer('${imp.id}')">${util().sanitize(imp.container_number||'—')}</span></td>
      <td>${util().sanitize(imp.suppliers?.name||'—')}</td>
      <td>${util().sanitize(imp.origin_country||'—')}</td>
      <td>${util().sanitize(imp.port_of_entry||'—')}</td>
      <td>${imp.eta ? util().formatDate(imp.eta) : '—'}</td>
      ${window.SM.AUTH.canSeeCost()?`<td>${imp.landed_cost ? util().formatCurrency(imp.landed_cost) : '—'}</td>`:'<td>—</td>'}
      <td>${util().pill(imp.status)}</td>
      <td><div class="ims__btn-group">
        <button class="ims__btn ims__btn--secondary ims__btn--sm ims__btn--icon" onclick="window.IMS_IMPORTS.openContainer('${imp.id}')"><i class="ti ti-eye"></i></button>
        ${imp.status==='cleared'?`<button class="ims__btn ims__btn--primary ims__btn--sm" onclick="window.IMS_IMPORTS.beginGRN('${imp.id}')"><i class="ti ti-clipboard-check"></i> GRN</button>`:''}
        ${imp.status==='grn_pending'?`<button class="ims__btn ims__btn--secondary ims__btn--sm" onclick="window.IMS_IMPORTS.openGRN('${imp.id}')"><i class="ti ti-clipboard-check"></i> GRN</button>`:''}
        <button class="ims__btn ims__btn--secondary ims__btn--sm ims__btn--icon" onclick="window.IMS_IMPORTS.printContainer('${imp.id}')"><i class="ti ti-printer"></i></button>
      </div></td>
    </tr>`).join('');
  }

  async function openContainer(importId) {
    const { data: imp } = await db().select('imports', { select: '*, suppliers(*), purchase_orders(po_number), import_items(id,qty_expected,qty_received,qty_remaining,products(id,name,sku))', eq: { id: importId }, maybeSingle: true, noCompanyFilter: true });
    if (!imp) return;
    const { data: grn } = await db().select('grn_records', { select: '*, grn_discrepancies(*)', eq: { import_id: importId }, maybeSingle: true, noCompanyFilter: true });
    const totalReceived = (imp.import_items||[]).reduce((s,i)=>s+(i.qty_received||0),0);
    const totalRemaining = (imp.import_items||[]).reduce((s,i)=>s+(i.qty_remaining||0),0);
    const totalSold = totalReceived - totalRemaining;
    const totalRevenue = await Promise.all((imp.import_items||[]).map(async item => {
      if (!item.products?.id) return 0;
      const sold = (item.qty_received||0)-(item.qty_remaining||0);
      const rrp = await db().getProductPrice(item.products.id,'rrp');
      return sold*(rrp||0);
    })).then(arr=>arr.reduce((s,v)=>s+v,0));
    const grossMargin = totalRevenue-(imp.landed_cost||0);

    ui().openModal(`Container: ${imp.container_number||'—'}`, `
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:14px">
        <div><span class="ims__label">Container #</span><div style="font-weight:700;font-size:16px">${util().sanitize(imp.container_number||'—')}</div></div>
        <div><span class="ims__label">Status</span><div>${util().pill(imp.status)}</div></div>
        <div><span class="ims__label">Supplier</span><div>${util().sanitize(imp.suppliers?.name||'—')}</div></div>
        <div><span class="ims__label">PO number</span><div>${util().sanitize(imp.purchase_orders?.po_number||'—')}</div></div>
        <div><span class="ims__label">Country of origin</span><div>${util().sanitize(imp.origin_country||'—')}</div></div>
        <div><span class="ims__label">Port of entry</span><div>${util().sanitize(imp.port_of_entry||'—')}</div></div>
        <div><span class="ims__label">ETA</span><div>${imp.eta?util().formatDate(imp.eta):'—'}</div></div>
        <div><span class="ims__label">Arrival</span><div>${imp.arrival_date?util().formatDate(imp.arrival_date):'—'}</div></div>
        ${window.SM.AUTH.canSeeCost()?`<div><span class="ims__label">Landed cost</span><div style="font-weight:600">${util().formatCurrency(imp.landed_cost)}</div></div>`:''}
        <div><span class="ims__label">Clearance</span><div>${imp.clearance_date?util().formatDate(imp.clearance_date):'—'}</div></div>
        ${imp.duty_notes?`<div style="grid-column:1/-1"><span class="ims__label">Duty notes</span><div>${util().sanitize(imp.duty_notes)}</div></div>`:''}
      </div>
      <hr class="ims__divider">
      <strong style="font-size:13px">Products in this container</strong>
      <div class="ims__table-wrap" style="margin-top:8px">
        <table class="ims__table">
          <thead><tr><th>Product</th><th>SKU</th><th>Expected</th><th>Received</th><th>Sold</th><th>Remaining</th></tr></thead>
          <tbody>${(imp.import_items||[]).map(item=>{const sold=(item.qty_received||0)-(item.qty_remaining||0);return`<tr>
            <td>${util().sanitize(item.products?.name||'—')}</td>
            <td>${util().sanitize(item.products?.sku||'—')}</td>
            <td>${item.qty_expected||0}</td><td>${item.qty_received||0}</td>
            <td>${sold}</td>
            <td style="font-weight:600">${item.qty_remaining||0}</td>
          </tr>`;}).join('')||'<tr><td colspan="6" class="ims__table-empty">No products recorded</td></tr>'}
          </tbody>
        </table>
      </div>
      <hr class="ims__divider">
      <strong style="font-size:13px">Summary</strong>
      <div style="display:grid;grid-template-columns:repeat(3,1fr);gap:8px;margin-top:10px">
        <div class="ims__stat" style="padding:10px"><div class="ims__stat-label">Received</div><div class="ims__stat-value" style="font-size:18px">${totalReceived}</div></div>
        <div class="ims__stat" style="padding:10px"><div class="ims__stat-label">Sold</div><div class="ims__stat-value" style="font-size:18px">${totalSold}</div></div>
        <div class="ims__stat" style="padding:10px"><div class="ims__stat-label">Remaining</div><div class="ims__stat-value" style="font-size:18px">${totalRemaining}</div></div>
        ${window.SM.AUTH.canSeeCost()?`<div class="ims__stat" style="padding:10px"><div class="ims__stat-label">Revenue</div><div class="ims__stat-value" style="font-size:14px">${util().formatCurrency(totalRevenue)}</div></div><div class="ims__stat" style="padding:10px"><div class="ims__stat-label">Landed cost</div><div class="ims__stat-value" style="font-size:14px">${util().formatCurrency(imp.landed_cost)}</div></div><div class="ims__stat" style="padding:10px"><div class="ims__stat-label">Gross margin</div><div class="ims__stat-value ims__stat-value--${grossMargin>=0?'success':'danger'}" style="font-size:14px">${util().formatCurrency(grossMargin)}</div></div>`:''}
      </div>
      ${grn?.grn_discrepancies?.length?`
        <hr class="ims__divider">
        <strong style="font-size:13px;color:var(--ims-danger)">GRN Discrepancies</strong>
        <div class="ims__table-wrap" style="margin-top:8px">
          <table class="ims__table">
            <thead><tr><th>Product</th><th>Expected</th><th>Received</th><th>Variance</th><th>Reason</th></tr></thead>
            <tbody>${grn.grn_discrepancies.map(d=>`<tr>
              <td>${util().sanitize(d.product_name||'—')}</td>
              <td>${d.expected_qty}</td><td>${d.received_qty}</td>
              <td style="color:${d.variance<0?'var(--ims-danger)':'var(--ims-success)'};font-weight:600">${d.variance>0?'+':''}${d.variance}</td>
              <td>${util().sanitize(d.reason||'—')}</td>
            </tr>`).join('')}
            </tbody>
          </table>
        </div>`:''}
    `,`
      <button class="ims__btn ims__btn--ghost" onclick="window.IMS_IMPORTS.printContainer('${imp.id}')"><i class="ti ti-printer"></i> Print</button>
      ${imp.status==='cleared'?`<button class="ims__btn ims__btn--primary" onclick="window.IMS_IMPORTS.beginGRN('${imp.id}')"><i class="ti ti-clipboard-check"></i> Begin GRN</button>`:''}
      ${imp.status==='grn_pending'?`<button class="ims__btn ims__btn--primary" onclick="window.IMS_IMPORTS.openGRN('${imp.id}')"><i class="ti ti-clipboard-check"></i> Complete GRN</button>`:''}
      <div style="display:flex;gap:8px;align-items:center">
        ${imp.status==='in_warehouse'?
          `<span style="font-size:12px;color:var(--ims-success)"><i class="ti ti-circle-check"></i> Stock in warehouse — no further status updates</span>`
        :`<select class="ims__select" id="ims-imp-status-sel" style="font-size:12px;width:auto">
          <option value="">Update status...</option>
          <option value="ordered">Ordered</option><option value="in_transit">In transit</option>
          <option value="customs">Customs</option><option value="cleared">Cleared</option>
        </select>
        <button class="ims__btn ims__btn--secondary" onclick="window.IMS_IMPORTS.updateStatus('${imp.id}')">Update</button>`}
        <button class="ims__btn ims__btn--ghost" onclick="window.SM.UI.closeModal()">Close</button>
      </div>
    `,'xl');
  }

  async function updateStatus(importId) {
    const sel = document.getElementById('ims-imp-status-sel');
    if (!sel?.value) return;
    const updates = { status: sel.value };
    if (sel.value === 'cleared') updates.clearance_date = new Date().toISOString().split('T')[0];
    await db().update('imports', importId, updates);
    ui().closeModal(); ui().toast('Status updated', 'success'); load();
  }

  async function beginGRN(importId) {
    const { data: imp } = await db().select('imports', { select: '*, import_items(id,qty_expected,products(name,sku))', eq: { id: importId }, maybeSingle: true, noCompanyFilter: true });
    if (!imp) return;
    const { data: lastGRN } = await db().select('grn_records', { select: 'grn_number', order: { col: 'created_at', asc: false }, limit: 1 });
    const grnNumber = util().generateRef('GRN', lastGRN?.[0]?.grn_number);
    const { data: grn, error } = await db().insert('grn_records', { import_id: importId, grn_number: grnNumber, status: 'in_progress', arrival_time: new Date().toISOString(), completed_by: window.SM.AUTH.user?.id });
    if (error) { ui().toast('Failed to create GRN: ' + error.message, 'error'); return; }
    await db().update('imports', importId, { status: 'grn_pending', arrival_date: new Date().toISOString().split('T')[0] });
    ui().closeModal();
    ui().toast(`GRN ${grnNumber} created`, 'success');
    openGRN(importId, grn.id);
  }

  async function openGRN(importId, grnId = null) {
    const { data: imp } = await db().select('imports', { select: '*, import_items(id,qty_expected,qty_received,products(id,name,sku))', eq: { id: importId }, maybeSingle: true, noCompanyFilter: true });
    if (!imp) return;
    if (!grnId) { const { data: eg } = await db().select('grn_records', { eq: { import_id: importId }, maybeSingle: true, noCompanyFilter: true }); if (eg) grnId = eg.id; }
    const items = imp.import_items || [];
    ui().openModal(`GRN: ${imp.container_number||'—'}`, `
      <div class="ims__alert ims__alert--info"><i class="ti ti-info-circle"></i><span>Enter actual quantities received. Discrepancies recorded automatically.</span></div>
      <div class="ims__table-wrap">
        <table class="ims__table">
          <thead><tr><th>Product</th><th>SKU</th><th>Expected</th><th>Actual received</th><th>Condition</th><th>Notes</th></tr></thead>
          <tbody>${items.map((item,i)=>`<tr>
            <td>${util().sanitize(item.products?.name||'—')}</td>
            <td>${util().sanitize(item.products?.sku||'—')}</td>
            <td style="font-weight:600">${item.qty_expected||0}</td>
            <td><input class="ims__input" type="number" min="0" value="${item.qty_received||item.qty_expected||0}" id="ims-grn-qty-${i}" data-item-id="${item.id}" data-expected="${item.qty_expected||0}" data-product-id="${item.products?.id||''}" data-product-name="${util().sanitize(item.products?.name||'')}" data-sku="${util().sanitize(item.products?.sku||'')}" style="width:80px" oninput="window.IMS_IMPORTS.checkVariance(${i})">
            <span id="ims-grn-variance-${i}" style="font-size:11px;margin-left:6px"></span></td>
            <td><select class="ims__select" id="ims-grn-cond-${i}" style="font-size:12px;width:auto"><option value="good">Good</option><option value="damaged">Damaged</option><option value="missing">Missing</option></select></td>
            <td><input class="ims__input" type="text" id="ims-grn-note-${i}" placeholder="Notes" style="font-size:12px"></td>
          </tr>`).join('')}
          </tbody>
        </table>
      </div>
      <div class="ims__form-group" style="margin-top:12px"><label class="ims__label">General notes</label><textarea class="ims__textarea" id="ims-grn-notes" rows="2"></textarea></div>
    `,`
      <button class="ims__btn ims__btn--ghost" onclick="window.IMS_IMPORTS.printGRNSheet('${importId}')"><i class="ti ti-printer"></i> Print GRN sheet</button>
      <button class="ims__btn ims__btn--ghost" onclick="window.SM.UI.closeModal()">Cancel</button>
      <button class="ims__btn ims__btn--primary" onclick="window.IMS_IMPORTS.confirmGRN('${importId}','${grnId||''}',${items.length})"><i class="ti ti-check"></i> Confirm &amp; update stock</button>
    `,'xl');
  }

  function checkVariance(i) {
    const input = document.getElementById(`ims-grn-qty-${i}`);
    const varEl = document.getElementById(`ims-grn-variance-${i}`);
    if (!input||!varEl) return;
    const v = (parseInt(input.value)||0)-(parseInt(input.dataset.expected)||0);
    if (v===0) { varEl.textContent=''; return; }
    varEl.textContent = `${v>0?'+':''}${v}`;
    varEl.style.color = v<0?'var(--ims-danger)':'var(--ims-success)';
  }

  async function confirmGRN(importId, grnId, itemCount) {
    const { data: whs } = await db().select('warehouses', { eq: { is_active: true } });
    if (!whs?.length) { ui().toast('No warehouses configured. Add a warehouse first.', 'error'); return; }
    const warehouse = whs[0];
    const grnData = [];
    for (let i=0;i<itemCount;i++) {
      const input=document.getElementById(`ims-grn-qty-${i}`);
      const condEl=document.getElementById(`ims-grn-cond-${i}`);
      const noteEl=document.getElementById(`ims-grn-note-${i}`);
      if (!input) continue;
      grnData.push({ itemId:input.dataset.itemId, productId:input.dataset.productId, productName:input.dataset.productName, sku:input.dataset.sku, expected:parseInt(input.dataset.expected)||0, received:parseInt(input.value)||0, condition:condEl?.value||'good', notes:noteEl?.value||'', variance:(parseInt(input.value)||0)-(parseInt(input.dataset.expected)||0) });
    }
    // Block if linked PO already has items received via PO route
    const {data:imp2}=await db().select('imports',{select:'po_id',eq:{id:importId},maybeSingle:true,noCompanyFilter:true});
    if(imp2?.po_id){
      const {data:alreadyReceived}=await window.supabase.createClient(window.IMS_SUPABASE_URL,window.IMS_SUPABASE_ANON_KEY,{global:{headers:{Authorization:`Bearer ${window.SM.AUTH.session?.access_token}`}}})
        .from('po_items').select('qty_received').eq('po_id',imp2.po_id).gt('qty_received',0).limit(1);
      if(alreadyReceived?.length){
        ui().toast('Cannot confirm GRN — goods were already received via the linked PO. Check stock levels for duplicates before proceeding.','error',8000);
        return;
      }
    }
    const notes = document.getElementById('ims-grn-notes')?.value||'';
    for (const item of grnData) {
      await db().update('import_items', item.itemId, { qty_received:item.received, qty_remaining:item.received, condition:item.condition, notes:item.notes });
      if (item.variance!==0 && grnId) {
        await db().insert('grn_discrepancies', { grn_id:grnId, product_id:item.productId||null, product_name:item.productName, sku:item.sku, expected_qty:item.expected, received_qty:item.received, variance:item.variance, reason:item.condition==='damaged'?'Damaged in transit':item.variance<0?'Short delivery':'Excess delivery' });
      }
      if (item.productId && item.received>0) {
        const { data: existing } = await db().select('stock_levels', { eq: { product_id:item.productId, warehouse_id:warehouse.id }, maybeSingle:true, noCompanyFilter:true });
        if (existing) { await db().update('stock_levels', existing.id, { quantity:(existing.quantity||0)+item.received, last_updated:new Date().toISOString() }); }
        else { await db().insert('stock_levels', { product_id:item.productId, warehouse_id:warehouse.id, quantity:item.received, reserved_qty:0 }); }
        await db().insert('stock_movements', { product_id:item.productId, warehouse_id:warehouse.id, movement_type:'import_received', quantity:item.received, reference:`GRN-${importId}`, reason:'Container receipt', user_id:window.SM.AUTH.user?.id });
      }
    }
    if (grnId) await db().update('grn_records', grnId, { status:'confirmed', confirmed_at:new Date().toISOString(), notes });
    await db().update('imports', importId, { status:'in_warehouse' });
    // Mark linked PO as completed so goods cannot be double-received via PO.
    // Reuses imp2 (already fetched above for the duplicate-receipt check)
    // instead of re-querying — and now surfaces an error if this update
    // fails, rather than silently succeeding while leaving the PO stuck
    // on 'sent' (which previously caused it to sit indefinitely in
    // Warehouse → Receiving even though stock had already been added).
    if(imp2?.po_id){
      const {error:poErr}=await db().update('purchase_orders',imp2.po_id,{status:'completed'});
      if(poErr){
        ui().toast('GRN confirmed and stock updated, but the linked PO could not be marked completed: '+poErr.message+' — please check Warehouse → Receiving and update it manually if it still appears there.','warning',10000);
      }
    }
    ui().closeModal();
    ui().toast('GRN confirmed — stock updated', 'success', 5000);
    setTimeout(()=>{ ui().confirm('Print Put Away sheet for warehouse staff?', ()=>printPutAwaySheet(importId), 'Print Put Away sheet'); }, 500);
    load();
  }

  async function printGRNSheet(importId) {
    const { data: imp } = await db().select('imports', { select:'*, suppliers(name), import_items(qty_expected,products(name,sku))', eq:{id:importId}, maybeSingle:true, noCompanyFilter:true });
    if (!imp) return;

    const infoRows=[
      ['Container', util().sanitize(imp.container_number||'—')],
      ['Supplier', util().sanitize(imp.suppliers?.name||'—')],
      ['Date', util().formatDate(new Date().toISOString())]
    ];
    const infoTableHtml=window.PRINT.table({
      colWidths:['30%','70%'],
      columns:[{label:'Field'},{label:'Value'}],
      rows:infoRows
    });

    const itemRows=(imp.import_items||[]).map(i=>[
      util().sanitize(i.products?.name||'—'),
      util().sanitize(i.products?.sku||'—'),
      String(i.qty_expected||0),
      '&nbsp;','&nbsp;','&nbsp;','&nbsp;'
    ]);
    const itemTableHtml=window.PRINT.table({
      colWidths:['22%','12%','12%','14%','12%','16%','12%'],
      columns:[
        {label:'Product'},{label:'SKU'},{label:'Expected'},
        {label:'Actual received'},{label:'Condition'},{label:'Notes'},{label:'Sign'}
      ],
      rows:itemRows
    });

    const headerHtml=window.PRINT.header({
      title:'Goods Receipt Note',
      docRef:imp.container_number
    });

    const sigFooterHtml=`
      <div style="margin-top:20px;display:flex;gap:40px;align-items:center;font-size:9pt">
        <div>Received by: ${window.PRINT.signatureBox(140)}</div>
        <div>Date/Time: ${window.PRINT.signatureBox(140)}</div>
        <div>Signature: ${window.PRINT.signatureBox(140)}</div>
      </div>`;

    const page=`
      ${headerHtml}
      <hr class="rule">
      ${infoTableHtml}
      <div class="st" style="margin-top:14px">Products</div>
      <hr class="rule">
      ${itemTableHtml}
      ${sigFooterHtml}
    `;

    window.PRINT.renderDocument([page],`GRN — ${imp.container_number||importId}`);
  }

  async function printPutAwaySheet(importId) {
    const { data: imp } = await db().select('imports', { select:'*, import_items(qty_received,products(name,sku,default_bin))', eq:{id:importId}, maybeSingle:true, noCompanyFilter:true });
    if (!imp) return;

    const infoRows=[
      ['Container', util().sanitize(imp.container_number||'—')],
      ['Date', util().formatDate(new Date().toISOString())]
    ];
    const infoTableHtml=window.PRINT.table({
      colWidths:['30%','70%'],
      columns:[{label:'Field'},{label:'Value'}],
      rows:infoRows
    });

    const itemRows=(imp.import_items||[]).filter(i=>(i.qty_received||0)>0).map(i=>[
      util().sanitize(i.products?.name||'—'),
      util().sanitize(i.products?.sku||'—'),
      String(i.qty_received||0),
      `<span style="color:#2563EB">${util().sanitize(i.products?.default_bin||'—')}</span>`,
      '&nbsp;','&nbsp;'
    ]);
    const itemTableHtml=window.PRINT.table({
      colWidths:['26%','16%','12%','16%','18%','12%'],
      columns:[
        {label:'Product'},{label:'SKU'},{label:'Qty'},
        {label:'Default bin'},{label:'Assigned location'},{label:'Sign'}
      ],
      rows:itemRows
    });

    const headerHtml=window.PRINT.header({
      title:'Put Away Sheet',
      docRef:imp.container_number
    });

    const sigFooterHtml=`
      <div style="margin-top:20px;display:flex;gap:40px;align-items:center;font-size:9pt">
        <div>Completed by: ${window.PRINT.signatureBox(140)}</div>
        <div>Date: ${window.PRINT.signatureBox(140)}</div>
        <div>Signature: ${window.PRINT.signatureBox(140)}</div>
      </div>
      <div style="margin-top:10px;font-size:8pt;color:#666">Return this sheet to office once complete.</div>`;

    const page=`
      ${headerHtml}
      <hr class="rule">
      ${infoTableHtml}
      <div class="st" style="margin-top:14px">Products to locate</div>
      <hr class="rule">
      ${itemTableHtml}
      ${sigFooterHtml}
    `;

    window.PRINT.renderDocument([page],`Put Away — ${imp.container_number||importId}`);
  }

  async function printContainer(importId) {
    const { data: imp } = await db().select('imports', { select:'*, suppliers(name), purchase_orders(po_number), import_items(qty_expected,qty_received,qty_remaining,products(name,sku))', eq:{id:importId}, maybeSingle:true, noCompanyFilter:true });
    if (!imp) return;

    const infoRows=[
      ['Container #', util().sanitize(imp.container_number||'—')],
      ['Supplier', util().sanitize(imp.suppliers?.name||'—')],
      ['PO', util().sanitize(imp.purchase_orders?.po_number||'—')],
      ['Origin', util().sanitize(imp.origin_country||'—')]
    ];
    if (window.SM.AUTH.canSeeCost()) {
      infoRows.push(['Landed cost', util().formatCurrency(imp.landed_cost)]);
    }
    const infoTableHtml=window.PRINT.table({
      colWidths:['30%','70%'],
      columns:[{label:'Field'},{label:'Value'}],
      rows:infoRows
    });

    const itemRows=(imp.import_items||[]).map(i=>{
      const sold=(i.qty_received||0)-(i.qty_remaining||0);
      return [
        util().sanitize(i.products?.name||'—'),
        util().sanitize(i.products?.sku||'—'),
        String(i.qty_expected||0),
        String(i.qty_received||0),
        String(sold),
        String(i.qty_remaining||0)
      ];
    });
    const itemTableHtml=window.PRINT.table({
      colWidths:['28%','16%','14%','14%','14%','14%'],
      columns:[
        {label:'Product'},{label:'SKU'},{label:'Expected'},
        {label:'Received'},{label:'Sold'},{label:'Remaining'}
      ],
      rows:itemRows
    });

    const headerHtml=window.PRINT.header({
      title:'Container Intelligence Report',
      docRef:imp.container_number
    });

    const page=`
      ${headerHtml}
      <hr class="rule">
      ${infoTableHtml}
      <div class="st" style="margin-top:14px">Products</div>
      <hr class="rule">
      ${itemTableHtml}
    `;

    window.PRINT.renderDocument([page],`Container Report — ${imp.container_number||importId}`);
  }

  async function showNewImport() {
    const { data: suppliers } = await db().select('suppliers', { eq:{is_active:true}, order:{col:'name'} });
    const { data: pos } = await db().select('purchase_orders', { eq:{status:'sent'}, order:{col:'created_at',asc:false} });
    const supOpts = (suppliers||[]).map(s=>`<option value="${s.id}">${util().sanitize(s.name)}</option>`).join('');
    const poOpts = (pos||[]).map(p=>`<option value="${p.id}">${util().sanitize(p.po_number)}</option>`).join('');
    _importItems = [];
    ui().openModal('New import',`
      <div class="ims__form-grid">
        <div class="ims__form-group"><label class="ims__label ims__label--req">Container number</label><input class="ims__input" type="text" id="ims-nimp-container" placeholder="e.g. MSKU1234567"></div>
        <div class="ims__form-group"><label class="ims__label ims__label--req">Supplier</label><select class="ims__select" id="ims-nimp-supplier"><option value="">Select supplier</option>${supOpts}</select></div>
        <div class="ims__form-group"><label class="ims__label">Linked PO</label><select class="ims__select" id="ims-nimp-po" onchange="window.IMS_IMPORTS.onPOSelected()"><option value="">None</option>${poOpts}</select></div>
        <div class="ims__form-group"><label class="ims__label ims__label--req">Country of origin</label><input class="ims__input" type="text" id="ims-nimp-country" placeholder="e.g. China"></div>
        <div class="ims__form-group"><label class="ims__label">Port of entry</label><input class="ims__input" type="text" id="ims-nimp-port" placeholder="e.g. Felixstowe"></div>
        <div class="ims__form-group"><label class="ims__label">ETA</label><input class="ims__input" type="date" id="ims-nimp-eta"></div>
        ${window.SM.AUTH.canSeeCost()?`<div class="ims__form-group"><label class="ims__label">Landed cost (£)</label><input class="ims__input" type="number" step="0.01" id="ims-nimp-cost"></div>`:''}
        <div class="ims__form-group"><label class="ims__label">Status</label><select class="ims__select" id="ims-nimp-status"><option value="ordered">Ordered</option><option value="in_transit">In transit</option><option value="customs">Customs</option><option value="cleared">Cleared</option></select></div>
        <div class="ims__form-group ims__form-group--full"><label class="ims__label">Duty notes</label><textarea class="ims__textarea" id="ims-nimp-notes" rows="2"></textarea></div>
      </div>
      <hr class="ims__divider">
      <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:10px">
        <strong style="font-size:13px">Products in this container</strong>
        <button class="ims__btn ims__btn--secondary ims__btn--sm" onclick="window.IMS_IMPORTS.addImportItem()"><i class="ti ti-plus"></i> Add product</button>
      </div>
      <div id="ims-nimp-items"><div style="font-size:12px;color:var(--ims-text-muted);padding:8px 0">No products added yet</div></div>
    `,`
      <button class="ims__btn ims__btn--ghost" onclick="window.SM.UI.closeModal()">Cancel</button>
      <button class="ims__btn ims__btn--primary" onclick="window.IMS_IMPORTS.saveImport()"><i class="ti ti-check"></i> Create import</button>
    `,'lg');
  }

  let _importItems = [];
  function addImportItem() { _importItems.push({productId:'',productName:'',sku:'',qtyExpected:0}); renderImportItems(); }
  async function onPOSelected(){
    const poId=document.getElementById('ims-nimp-po')?.value;
    if(!poId) return;

    const client=window.supabase.createClient(window.IMS_SUPABASE_URL,window.IMS_SUPABASE_ANON_KEY);
    const {data:po,error}=await client
      .from('purchase_orders')
      .select('supplier_id,currency,po_items(product_id,product_name,sku,quantity,products(name,sku))')
      .eq('id',poId)
      .maybeSingle();

    if(error||!po){ ui().toast('Could not load PO items','error'); return; }

    const supSel=document.getElementById('ims-nimp-supplier');
    const curSel=document.getElementById('ims-nimp-currency');
    if(supSel&&po.supplier_id) supSel.value=po.supplier_id;
    if(curSel&&po.currency)    curSel.value=po.currency;

    const items=po.po_items||[];
    if(!items.length){ ui().toast('This PO has no line items','warning'); return; }

    _importItems=items.map(i=>({
      productId:   i.product_id||'',
      productName: i.product_name||i.products?.name||'',
      sku:         i.sku||i.products?.sku||'',
      qtyExpected: i.quantity||0
    }));

    renderImportItems();
    ui().toast(`${_importItems.length} product${_importItems.length!==1?'s':''} pulled from PO`,'success');
  }
  function renderImportItems() {
    const c = document.getElementById('ims-nimp-items');
    if (!c) return;
    if (!_importItems.length) { c.innerHTML='<div style="font-size:12px;color:var(--ims-text-muted);padding:8px 0">No products added yet</div>'; return; }
    c.innerHTML = _importItems.map((item,i)=>`
      <div style="display:grid;grid-template-columns:2fr 100px auto;gap:8px;align-items:center;margin-bottom:8px">
        <div style="position:relative">
          <input class="ims__input" type="text" placeholder="Product name or SKU" value="${util().sanitize(item.productName)}" autocomplete="off"
            oninput="window.IMS_IMPORTS.updateImportItem(${i},'productName',this.value);window.IMS_IMPORTS.searchImportProduct(${i},this.value)">
          <div id="ims-imp-prod-drop-${i}" class="ims__ac-dropdown"></div>
        </div>
        <input class="ims__input" type="number" min="0" value="${item.qtyExpected}" placeholder="Qty expected"
          oninput="window.IMS_IMPORTS.updateImportItem(${i},'qtyExpected',+this.value||0)">
        <button class="ims__btn ims__btn--danger ims__btn--sm ims__btn--icon" onclick="window.IMS_IMPORTS.removeImportItem(${i})"><i class="ti ti-trash"></i></button>
      </div>`).join('');
  }
  function updateImportItem(i,field,val){if(_importItems[i])_importItems[i][field]=val;}
  function removeImportItem(i){_importItems.splice(i,1);renderImportItems();}
  async function searchImportProduct(index,query){
    if(!query||query.length<2){const d=document.getElementById(`ims-imp-prod-drop-${index}`);if(d)d.style.display='none';return;}
    const {data:products}=await db().select('products',{ilike:{name:query},select:'id,name,sku',limit:6});
    const drop=document.getElementById(`ims-imp-prod-drop-${index}`);
    if(!drop||!products?.length){if(drop)drop.style.display='none';return;}
    drop.innerHTML=products.map(p=>`<div class="ims__ac-item" onmousedown="window.IMS_IMPORTS.selectImportProduct(${index},${JSON.stringify({id:p.id,name:p.name,sku:p.sku}).replace(/"/g,'&quot;')})"><strong>${util().sanitize(p.name)}</strong><span style="font-size:11px;color:var(--ims-text-muted);margin-left:6px">${p.sku}</span></div>`).join('');
    drop.style.display='block';
  }
  function selectImportProduct(index,product){
    if(_importItems[index]){_importItems[index].productId=product.id;_importItems[index].productName=product.name;_importItems[index].sku=product.sku;}
    renderImportItems();
    const drop=document.getElementById(`ims-imp-prod-drop-${index}`);if(drop)drop.style.display='none';
  }

  async function saveImport() {
    const g=id=>document.getElementById(id)?.value?.trim()||'';
    const container=g('ims-nimp-container'),supplierId=g('ims-nimp-supplier'),country=g('ims-nimp-country');
    if(!container){ui().toast('Container number required','error');return;}
    if(!supplierId){ui().toast('Please select a supplier','error');return;}
    if(!country){ui().toast('Country of origin required','error');return;}
    const {data:imp,error}=await db().insert('imports',{container_number:container,supplier_id:supplierId,po_id:g('ims-nimp-po')||null,origin_country:country,port_of_entry:g('ims-nimp-port')||null,eta:g('ims-nimp-eta')||null,landed_cost:parseFloat(g('ims-nimp-cost'))||null,status:g('ims-nimp-status')||'ordered',duty_notes:g('ims-nimp-notes')||null,created_by:window.SM.AUTH.user?.id});
    if(error){ui().toast('Failed: '+error.message,'error');return;}
    if(_importItems.length){
      const client=window.supabase.createClient(window.IMS_SUPABASE_URL,window.IMS_SUPABASE_ANON_KEY);
      await Promise.all(_importItems.map(item=>client.from('import_items').insert({import_id:imp.id,product_id:item.productId||null,product_name:item.productName,sku:item.sku||'',qty_expected:item.qtyExpected||0,qty_received:0,qty_remaining:0})));
    }
    _importItems=[];
    ui().closeModal();ui().toast(`Import ${container} created`,'success');load();
  }

  window.addEventListener('ims:panel',e=>{if(e.detail.panel==='imports')load();});
  window.addEventListener('ims:ready',()=>{
    document.getElementById('ims-imports-new-btn')?.addEventListener('click',showNewImport);
    ['ims-imports-search','ims-imports-status'].forEach(id=>{
      const el=document.getElementById(id);
      if(!el)return;
      el.addEventListener('input',util().debounce(load,350));
      el.addEventListener('change',load);
    });
  });

  window.IMS_IMPORTS={load,openContainer,updateStatus,beginGRN,openGRN,checkVariance,
  confirmGRN,printGRNSheet,printPutAwaySheet,printContainer,showNewImport,
  addImportItem,updateImportItem,removeImportItem,searchImportProduct,
  selectImportProduct,saveImport,onPOSelected};
})();
